import * as actions from '../actions/web3Actions';

const initialState =  {
  web3: null,
  myWalletAddress: null,
  status: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_WEB3:
      return {
        ...state,
        web3: action.payload || null
      };
    case actions.SET_MY_WALLET_ADDRESS:
      return {
        ...state,
        myWalletAddress: action.payload
      };
    case actions.SET_STATUS:
      return {
        ...state,
        status: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/web3Reducer.js